import { AnimatePresence } from 'framer-motion';
import { useCallback, useRef, useState } from 'react';

import { ImageModal } from './chat-image.modal';
import { ChatTopBar } from './chat-topbar';
import { MessageList } from './message-list';
import { ReportChatModal } from './report-chat.modal';

import { ImageData } from '@/slw/entities/chat';
import ChatBottomBar from '@/slw/features/chat/chat-bottombar.ui';
import { useIntersection } from '@/slw/shared/hooks/use-interceptor';
import { useChatStore } from '@/slw/shared/lib/firebase/chat-store';
import { cn } from '@/slw/shared/lib/utils';
import { useChatMessages } from '@/slw/features/chat';

interface ChatProps {
  isMobile: boolean;
  className?: string;
}

export function ChatMain({ isMobile, className }: ChatProps) {
  const { chatId, user } = useChatStore();
  const [showReport, setShowReport] = useState(false);

  // const [messages, setMessages] = useState<Message[]>([]);
  // const [messagesLength, setMessagesLength] = useState<number>(0);
  // const [messageLimit, setMessageLimit] = useState(10);
  // const [messagesSize, setMessagesSize] = useState<number>(messagesLength);
  // const [messagesDb, messagesSizeLoading] = useCollectionData(getMessagesQuery(messageLimit, chatId!));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageData, setImageData] = useState<ImageData | null>(null);
  // const [loading, setLoading] = useState(false);

  const scrollArea = useRef<HTMLDivElement>(null);
  const bottomSpan = useRef<HTMLSpanElement>(null);

  const isAtBottom = useIntersection(scrollArea, bottomSpan, {
    rootMargin: '0px 0px 300px',
    threshold: 1.0,
  });

  const scrollToBottom = useCallback((smooth?: boolean): void => {
    requestAnimationFrame(() => bottomSpan.current?.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto' }));
  }, []);

  const { messages, loading, loadingMore, hasMore, loadMoreMessages } = useChatMessages(chatId!);

  // useEffect(() => {
  //   const loadMessages = async () => {
  //     setLoading(true);
  //     setMessageLimit(10);
  //     const [chatsSnapshot, messagesLength] = await Promise.all([
  //       getDocs(getMessagesQuery(10, chatId!)),
  //       getMessagesSize(chatId!),
  //     ]);
  //     const messagesProp = chatsSnapshot.docs.map((doc) => doc.data());

  //     setMessages(messagesProp);
  //     setMessagesLength(messagesLength);
  //     setLoading(false);
  //     scrollToBottom(false, 1000);
  //   };

  //   if (chatId) {
  //     loadMessages();
  //   }
  // }, [chatId, scrollToBottom]);

  // const hasMore = useMemo(
  //   () => (messagesSize !== null ? messageLimit < messagesSize : false),
  //   [messagesSize, messageLimit],
  // );

  const handleLoadMore = useCallback(() => {
    loadMoreMessages();
    // setMessageLimit((prevLimit) => prevLimit + 10);
  }, [loadMoreMessages]);

  // const setDocumentLength = useCallback(async () => {
  //   const messagesSize = await getMessagesSize(chatId!);

  //   setMessagesSize(messagesSize);
  // }, [chatId]);

  // useEffect(() => {
  //   const loadData = async () => {
  //     if (messagesDb) {
  //       setLoading(true);
  //       await sleep(2000);
  //       setDocumentLength();
  //       setMessages(messagesDb);
  //       setLoading(false);
  //     }
  //   };

  //   loadData();
  // }, [setDocumentLength, messagesDb]);

  const openModal = (data: ImageData) => {
    setIsModalOpen(true);
    setImageData(data);
  };

  const handleReport = () => {
    setShowReport(true);
  };

  const handleActionClick = (actionType: string, messageIndex: number) => {
    // Action clicked
  };

  const handleCloseModal = (): void => setIsModalOpen(false);

  return (
    <div className={cn('flex flex-col justify-between w-full h-[calc(100%-44px)]', className)}>
      <ChatTopBar selectedUser={user} onReport={handleReport} />

      <MessageList
        bottomSpan={bottomSpan}
        isAtBottom={isAtBottom}
        onActionClick={handleActionClick}
        messages={messages}
        selectedUser={user}
        openModal={openModal}
        scrollToBottom={scrollToBottom}
        loading={loading}
        onLoadMore={handleLoadMore}
        hasMore={hasMore}
        loadingMore={loadingMore}
      />

      <ChatBottomBar isMobile={isMobile} openModal={openModal} scrollToBottom={scrollToBottom} />
      <AnimatePresence>
        {isModalOpen && imageData && <ImageModal imageData={imageData} closeModal={handleCloseModal} />}
      </AnimatePresence>
      {showReport && <ReportChatModal open={showReport} onOpenChange={() => setShowReport(!showReport)} />}
    </div>
  );
}
